import React from 'react'
import './SubmitButton.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'

interface SubmitButtonProps {
  loading: boolean
  disabled?: boolean
  onClick?: () => void
  text: string
}

const HuiSubmitButton: React.FC<SubmitButtonProps> = ({
  disabled = false,
  onClick,
  text,
  loading
}) => {
  return (
    <button
      className={`submit-button ${disabled ? 'disabled' : ''}`}
      disabled={disabled}
      onClick={onClick}
    >
      {loading ? (
        <div className="pulsate-loading"></div>
      ) : (
        <FontAwesomeIcon icon={faCircleCheck} className="button-icon" />
      )}
      <div className="button-text"> {text}</div>
    </button>
  )
}

export default HuiSubmitButton
